import Router from 'vue-router';

import routes from "./routes"

export default new Router(
  {
    mode: 'history',
    base: process.env.VUE_APP_BASE_URL,
    routes: routes
  });
